"use client";

import { useEffect, useState, type ReactNode } from "react";

/**
 * The header's one piece of state: whether the page has scrolled. Over a full-bleed hero the header starts see-through and
 * turns solid after 40 px; elsewhere it is solid from the start and only gains its soft shadow once content slides under.
 * The colour change is a CSS transition, which reduced motion turns off.
 */
export function HeaderState({ over, children }: { over: boolean; children: ReactNode }) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const threshold = over ? 40 : 4;
    const update = () => setScrolled(window.scrollY > threshold);
    update();
    window.addEventListener("scroll", update, { passive: true });
    return () => window.removeEventListener("scroll", update);
  }, [over]);
  return (
    <header className="hf-hdr" data-over={over ? "" : undefined} data-scrolled={scrolled ? "" : undefined}>
      {children}
    </header>
  );
}
